import { PropsWithChildren } from "react";
import { TextLink } from "@/src/components/links/components/TextLink";

interface RevealLinkProps {
  href: string;
}

export function RevealLink({ href }: PropsWithChildren<RevealLinkProps>) {
  return (
    <TextLink size="xs" className="relative z-1 block" href={href}>
      Reveal
    </TextLink>
  );
}
